import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const fillRateMetricsResponse = z.object({
  avg_fill_rate: z.number().nullable().optional(),
  total_requested_shifts: z.number().nullable().optional(),
  total_requested_shifts_forecast: z.number().nullable().optional(),
  total_hours_worked: z.number().nullable().optional(),
  total_filled_shifts: z.number().nullable().optional(),
})

export type FillRateMetrics = z.infer<typeof fillRateMetricsResponse>

export async function getFillRateMetrics(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_metrics', data, { signal })
    .then((response) => response.data)
    .then(fillRateMetricsResponse.parse)
}
